import { z } from 'zod';
export const projectsTimeLocationReferenceCapability = 'projects.time-location-reference.v1';
export const projectsTimeLocationReferenceSnapshotSchema = z.strictObject({
    contractVersion: z.literal(projectsTimeLocationReferenceCapability),
    projectId: z.string().uuid(),
    label: z.string().trim().min(1).max(500),
    projectRevision: z.number().int().positive(),
    locationConfigured: z.boolean(),
    latitudeE7: z.number().int().min(-900_000_000).max(900_000_000).nullable(),
    longitudeE7: z.number().int().min(-1_800_000_000).max(1_800_000_000).nullable(),
    radiusMillimeters: z.number().int().min(10_000).max(500_000).nullable(),
    locationRevision: z.number().int().positive().nullable(),
}).superRefine((snapshot, context) => {
    const locationValues = [
        snapshot.latitudeE7,
        snapshot.longitudeE7,
        snapshot.radiusMillimeters,
        snapshot.locationRevision,
    ];
    if (snapshot.locationConfigured !== locationValues.every((value) => value !== null)) {
        context.addIssue({
            code: 'custom',
            path: ['locationConfigured'],
            message: 'Project time-location fields must be all present or all absent.',
        });
    }
});
export const projectsSetTimeLocationSchema = z.strictObject({
    commandId: z.string().uuid(),
    expectedRevision: z.number().int().positive().nullable().default(null),
    latitudeE7: z.number().int().min(-900_000_000).max(900_000_000),
    longitudeE7: z.number().int().min(-1_800_000_000).max(1_800_000_000),
    radiusMillimeters: z.number().int().min(10_000).max(500_000),
    active: z.boolean().default(true),
});
export const projectsTimeLocationReferenceResponseSchema = z.strictObject({
    contractVersion: z.literal(projectsTimeLocationReferenceCapability),
    data: projectsTimeLocationReferenceSnapshotSchema,
    idempotent: z.boolean(),
});
//# sourceMappingURL=projects-time-location-reference.contract.js.map